<div class="container">
  <div>
    <svg-icon
      src="../../../../assets/icons/close_btn.svg"
      [svgStyle]="{ fill: '#ef3e42' }"
    ></svg-icon>
  </div>
  <div>
    <p class="title">{{ title }}</p>
    <p class="subtitle">{{ subtitle }}</p>
  </div>
</div>
